import { LocalPemissions } from "../types/LocalPemissions";

// prettier-ignore
export const localPemissions: LocalPemissions = {
 "account.create.accountType": [],
 "account.create.requisites": ["default", "numericIds"],
 "account.create.shortName": ["default", "numericIds"],
 "account.create.code": [],
 "account.create.actualIndex": ["default", "numericIds"],
 "account.create.actualDistrict": ["default", "numericIds"],
 "account.create.actualCity": ["default", "numericIds"],
 "account.create.actualVillage": ["default", "numericIds"],
 "account.create.actualStreet": ["default", "numericIds"],
 "account.create.actualHouse": ["default", "numericIds"],
 "account.create.actualBuilding": ["default", "numericIds"],
 "account.create.actualApartment": ["default", "numericIds"],
 "account.create.contactIndividual": [],
 "account.read.accountType": [],
 "account.create.exiteId": ["default", "numericIds"],
 "account.create.index": ["default", "numericIds"],
 "account.create.district": ["default", "numericIds"],
 "account.create.city": ["default", "numericIds"],
 "account.create.village": ["default", "numericIds"],
 "account.create.street": ["default", "numericIds"],
 "account.create.house": ["default", "numericIds"],
 "account.create.building": ["default", "numericIds"],
 "account.create.apartment": ["default", "numericIds"],
 "account.create.timezone": [],
 "account.create.responsibleUsers": [],
 "account.read.exiteId": ["default", "numericIds"],
 "account.read.requisites": ["default", "numericIds"],
 "account.read.responsibleUsers": [],

 "account.info": ["default", "numericIds"],
 "account.agreements": ["default", "numericIds"],
 "account.services": ["default", "numericIds"],
 "account.products": ["numericIds"],
 "account.bills": ["default", "numericIds"],
 "account.payments": ["default", "numericIds"],
 "account.charges": ["default", "numericIds"],
 "account.accumulators": ["default", "numericIds"],
 "account.detalization": ["default", "numericIds"],

 "account.balanceInfo": ["default", "numericIds"],
 "account.contactList": [],
 "account.contactListDetails": [],

 "feature.upload.price": [],
 // Features
 "offering.groupOffer": ["numericIds"],
 "feature.accountPaymentsRebase": ["numericIds", "default"],
 "feature.accountPaymentsCancel": ["numericIds", "default"],
 "feature.createAccount": ["numericIds", "default"],
 "feature.roles": ["numericIds", "default"],
 "feature.accounts/list": ["numericIds", "default"],
 "feature.accounts/individual": ["numericIds", "default"],
};
